import { combineReducers } from "@reduxjs/toolkit";

// ** reducers imports
import resetPasswordSlicer from "./userRoute/resetPassword/resetPassword.slicer";
import authenticateSlicer from "./userRoute/authenticate/authenticate.slicer";
import forgotPasswordSlicer from "./userRoute/forgotPassword/forgotPassword.slicer";
import feedbackReducer from "./userRoute/feedback/slicer";
import verifyMailSlicer from "./userRoute/verifyMail/verifyMail.slicer";
import guestShopSlicer from "./userRoute/guestShop/guestShop.slicer";
import orderFoodSlicer from "./userRoute/orderFood/orderFood.slicer";

const rootReducer = combineReducers({
	forgetPassword: forgotPasswordSlicer,
	resetPassword: resetPasswordSlicer,
	authenticate: authenticateSlicer,
	feedback: feedbackReducer,
	verifyMail: verifyMailSlicer,
	guestShop: guestShopSlicer,
	orderFood: orderFoodSlicer,
});

export default rootReducer;
